function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.50033 12.0005H8.50633M8.50033 6.0002V9.75036M16.0007 9.00033C16.0007 4.8579 12.6428 1.5 8.50033 1.5C4.3579 1.5 1 4.8579 1 9.00033C1 13.1428 4.3579 16.5007 8.50033 16.5007C12.6428 16.5007 16.0007 13.1428 16.0007 9.00033Z",
    stroke: "#E5A503",
    style: {
      stroke: "#E5A503",
      stroke: "color(display-p3 0.8980 0.6471 0.0118)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.5ea4d01ef2129e352d58e1757e1c522f.svg";
export { ForwardRef as ReactComponent };